var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{attrs:{"loading":_vm.loading,"icon":"mdi-delete","color":"error"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.$t('delete'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }